import addNewDepartmentIcon from "../../assets/icons/shop-add.svg";

interface IAddNewAccountDropDownProps {
  openAddNewAccountModal: () => void;
}

export const AddNewAccountDropDown = (props: IAddNewAccountDropDownProps) => {
  return (
    <div
      // className={props.header}
      className="header-menu-dropdown-content-item add-new-business--button"
    >
      <div
        className="flex-container header-menu-dropdown--button"
        onClick={props.openAddNewAccountModal}
      >
        <img
          src={addNewDepartmentIcon}
          alt="add department"
          className="department-view--icon"
        />
        <div className="flex-container">
          <span className="department-name">New Business</span>
        </div>
      </div>
    </div>
  );
};
